import React, { useEffect, useState } from 'react';
import FileUploadClientForm from './standartFields/FileUploadClientForm';
import EmailClientForm from './standartFields/EmailClientForm';
import DateClientForm from './standartFields/DateClientForm';
import NumberClientForm from './standartFields/NumberClientForm';
import SingleLineClientForm from './standartFields/SingleLineClientForm';
import ParagraphClientForm from './standartFields/ParagraphClientForm';
import { applicationStore } from 'src/store/ApplicationStore';
import MultipleSelectClientForm from './standartFields/MultipleSelectClientForm';
import SingleSelectClientForm from './standartFields/SingleSelectClientForm';
import YesNoQuestionClientForm from './standartFields/YesNoQuestionClientForm';
import WebsiteClientForm from './standartFields/WebsiteClientForm';
import SectionBreakClientForm from './standartFields/SectionBreakClientForm';
import logger from 'src/utils/logger';
import CountryClientForm from './standartFields/CountryClientForm';
import { Button } from '../ui/Button';
import TrashIcon from 'src/assets/images/svg/TrashIcon';
import PhoneNumberClientForm from './standartFields/PhoneNumberClientForm';
import DropdownWithAntClientForm from './standartFields/DropdownWithAntClientForm';
import { generateKeyIndividualOrEntitySection } from 'src/helpers/generateKeyIndividualEntitySection';
import AddressLineClientForm from './standartFields/AddressLineClientForm';
import { useTranslation } from 'react-i18next';
import { getFormLabel, getFormPlaceholder, getFormInstructions } from 'src/helpers/multilingualHelper';


const ClientFormField = ({ element, setValue, ctry, setDisabled, setCtry, disabled, id, name, type, options, label, required, placeholder, register, errors, control, watch, fields, config, onChange, onAddFields, onRemoveFields, parentFields = [], value }) => {
    const [country, setCountry] = useState(ctry || null);
    const [formFields, setFormFields] = useState(fields);
    const [uboCounter, setUboCounter] = useState(1);
    let [disabledItem, setDisabledItem] = useState(disabled ? true : false);
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language || 'en';

    const [shouldRefresh, setShouldRefresh] = useState(false);
    useEffect(() => {
        const updatedFields = fields.map(field => {
            if (field.config && field.config.component === "Key Individuals and Entities") {
                return {
                    ...field,
                    fields: field.fields.map((subField, index) => ({
                        ...subField,
                        label: `${subField.label} 1`
                    }))
                };
            }
            return field;
        });

        setFormFields(updatedFields);
    }, [shouldRefresh]);

    const addUboFields = () => {
        const newCounter = uboCounter + 1;
        const templateSection = JSON.parse(JSON.stringify(element));
        if (!templateSection) return;

        const currentLanguage = i18n.language || 'en';
        const newSection = generateKeyIndividualOrEntitySection(templateSection, newCounter, applicationStore.clientFormOriginalFieldCount, currentLanguage);

        setFormFields([...formFields, newSection]);

        setUboCounter(newCounter);

        if (onAddFields) {
            onAddFields(id, newSection);
            setShouldRefresh((prev) => !prev);
        }
    };

    const removeLastUboFields = () => {
        if (uboCounter > 1) {
            const newCounter = uboCounter - 1;
            const uboId = `ubo_${uboCounter}`;

            const newFields = onRemoveFields(id, uboId);

            setFormFields(newFields);

            logger.log(newFields);

            setUboCounter(newCounter);
        }
    };

    const displayLabel = getFormLabel(label, currentLanguage);
    const displayPlaceholder = getFormPlaceholder(placeholder, currentLanguage);
    const displayInstructions = getFormInstructions(config?.instructions, currentLanguage);

    const commonProps = {
        elementId: id,
        type,
        label: displayLabel,
        name,
        required,
        placeholder: displayPlaceholder,
        register,
        errors,
        control,
        watch,
        config: {
            ...config,
            instructions: displayInstructions
        },
        onChange,
        fieldName: config?.fieldName,
        value,
        setValue
    };

    const renderComponent = () => {
        switch (type) {
            case "single-line":
                if (config.dbKey === 'address' || config.dbKey === 'registered_address') {
                    return (<>
                        <AddressLineClientForm register={register} fields={parentFields} disabled={disabled} country={ctry} setValue={setValue} setDisabled={setDisabled} id={`addressLine-${id}`} errors={errors} />
                        <SingleLineClientForm disabled={disabled} {...commonProps} />
                    </>)
                } else
                    return <SingleLineClientForm disabled={disabled} {...commonProps} />
            case "paragraph":
                return <ParagraphClientForm {...commonProps} />;
            case "multiple-select":
                return <MultipleSelectClientForm {...commonProps} options={options} />;
            case "single-select":
                return <SingleSelectClientForm {...commonProps} options={options} />;
            case "dropdown":
                if (config.dbKey === "registered_city_state" || config.dbKey === "city_state") {
                    return <SingleLineClientForm disabled={disabled} {...commonProps} />
                } else {
                    return <DropdownWithAntClientForm {...commonProps} options={options} />;
                }
            case "date":
                return <DateClientForm {...commonProps} />;
            case "number":
                return <NumberClientForm {...commonProps} />;
            case "yes-no":
                return <YesNoQuestionClientForm {...commonProps} />;
            case "file":
                return <FileUploadClientForm {...commonProps} />;
            case "email":
                return <EmailClientForm {...commonProps} />;
            case "website":
                return <WebsiteClientForm {...commonProps} />;
            case "section-break":
                return <SectionBreakClientForm {...commonProps} />;
            case "phone":
                return <PhoneNumberClientForm {...commonProps} />;
            case "country":
                if (config.isMultiple) {
                    return <DropdownWithAntClientForm {...commonProps} options={options} />;
                } else {
                    return <CountryClientForm disabled={disabled} {...commonProps} options={options} setCountry={setCtry} setDisabled={setDisabled} />;
                }
            case "industry-type":
                return <DropdownWithAntClientForm {...commonProps} options={options} />;
            case "text":
                return <SingleLineClientForm {...commonProps} />;
            case "section":
                return (
                    <>
                        {config?.component === 'Address' &&
                            <div className="border-b pb-6 mb-2">
                                <div className='text-sm'>{t('clientForm.addressSectionTitle', 'Address')}</div>
                                <div className="flex text-xs text-gray-700">{t('clientForm.addressSectionDescription', 'Find or manually enter your address. Start by selecting your country.')}</div>
                            </div>
                        }
                        {formFields.map((field, index) => {
                            if (field.visible && !field.hidden) {
                                const fieldDisplayLabel = getFormLabel(field.label, currentLanguage);
                                const fieldDisplayPlaceholder = getFormPlaceholder(field.placeholder, currentLanguage);
                                const fieldDisplayInstructions = getFormInstructions(field.config?.instructions, currentLanguage);

                                return <ClientFormField
                                    setDisabled={setDisabledItem}
                                    disabled={disabledItem}
                                    ctry={country}
                                    setCtry={setCountry}
                                    setValue={setValue}
                                    element={element}
                                    key={field.id}
                                    id={field.id}
                                    name={field.name}
                                    type={field.config.type}
                                    options={field.config.options}
                                    label={fieldDisplayLabel}
                                    required={field.required}
                                    placeholder={fieldDisplayPlaceholder}
                                    register={register}
                                    errors={errors}
                                    control={control}
                                    watch={watch}
                                    fields={field.fields || []}
                                    parentFields={fields}
                                    config={{
                                        ...field.config,
                                        instructions: fieldDisplayInstructions
                                    }}
                                    onChange={onChange}
                                    value={field.value}
                                />
                            } else {
                                return null
                            }

                        })}
                        {config?.component === "Key Individuals and Entities" ?
                            <div className='flex w-full mb-5'>
                                <Button
                                    type="button"
                                    onClick={addUboFields}
                                    className="h-[44px] py-[4px] px-2"
                                    variant="secondaryWithoutIcon"
                                >
                                    {uboCounter > 1 ? "+" : t('clientForm.addKeyIndividualEntity', 'Add Key Individual/Entity')}
                                </Button>
                                {uboCounter > 1 && (
                                    <Button
                                        type="button"
                                        onClick={removeLastUboFields}
                                        className="ml-2 text-center h-[44px] py-[4px] px-2 bg-transparent hover:bg-FailRed400 hover:text-Gray50 focus:ring-FailRed400 text-FailRed400 border-FailRed400 border-[2px]"
                                        variant=""
                                    >
                                        <span className="">
                                            <TrashIcon width={24} height={24} />
                                        </span>
                                    </Button>
                                )}
                            </div>
                            :
                            null
                        }
                    </>
                );
            default:
                return null;
        }
    };

    return renderComponent();
};

export default ClientFormField;